module.exports = __webpack_public_path__ + "img/visa.bc0146fa.svg";